export const environment = {
  duuUploadBucket : 'bridge-qa5-bucket-duu-zip-upload',
  identityPoolId:  'us-east-2:d368c070-9664-4085-b15d-317b2a771934',
  s3_endpoint: '',
  sts_endpoint: '',
  s3_downUrl: 'https://s3.amazonaws.com',
  appVersion: 'Version 1.0.0',
  baseUrl: 'https://api.qa5.bridge.sportsmed.smith-nephew.com',
  baseUrlClp: 'https://api.qa5.bridge.sportsmed.smith-nephew.com',
  baseUrlClpSnn: 'https://api-snn.qa5.bridge.sportsmed.smith-nephew.com',
  baseUnauthUrl: 'https://api2.qa5.bridge.sportsmed.smith-nephew.com',
  userPoolAwsLogin:  'cognito-idp.us-east-2.amazonaws.com/us-east-2_aVlPy1zUF',
  production: true,
  lensSenderEmail: 'snnoreply@maildrop.cc',
  destinationBucket: 'cup-dev-lumino',
  region: 'us-east-2',
  apiVersionCognito: '2016-04-18',
  apiVersionSqs: '2012-11-05',
  lambdaFunction: {
    bridgeDuuProcessZipUpload: 'bridge-qa5-duu-process-zip-upload',
    lambdaRegion: 'us-east-2',
  },
  ssmParams: {
    IDLETIME : "/bridge-qa5/image-upload-service_qa5/inactivityTime_login",
    DIACOMTAG : "/bridge-qa5/image-upload-service_qa5/validDicomTags",
    RECALLTIME : "/bridge-qa5/image-upload-service_qa5/recallTime",
    AUDITINTERVALTIME : "/bridge-qa5/image-upload-service_qa5/auditInterval",
    APPVERSION: "/bridge-qa5/image-upload-service_qa5/appVersionInfo",
  	APPDIACOMTAGSCRIPT : "/bridge-qa5/image-upload-service_qa5/validApplicationDicomTags",
    SQSQUEUEURL: "/bridge-qa5/DUU_Group_by_patient/group-by-patient-queue-url",
    APPNAME: "/bridge-qa5/DUU_app_name/appName",
    IFUCONTENT:"/bridge-qa5/image-upload-service_qa5/IFUContent"
  },

  //ALL ROLES EXPECT SNN
  clp: {
    hostedUIUrl: "https://bridge-qa5-clp-auth.auth.us-east-2.amazoncognito.com/oauth2/",
    hostedUIlogout: "https://bridge-qa5-clp-auth.auth.us-east-2.amazoncognito.com/logout",
    identityPoolId: "us-east-2:d368c070-9664-4085-b15d-317b2a771934",
    userPoolId: "us-east-2_aVlPy1zUF",
    userPoolWebClientId: "70fktpmqotfquqta7163e4da4n",
    userPoolAwsLogin: "cognito-idp.us-east-2.amazonaws.com/us-east-2_aVlPy1zUF",
    cloudfrontCLPURL: 'https://clp.qa5.bridge.sportsmed.smith-nephew.com',
    cloudFrontCLPSignInUrl: 'https://clp.qa5.bridge.sportsmed.smith-nephew.com/signin',
    cloudFrontCLPSignOutUrl: 'https://clp.qa5.bridge.sportsmed.smith-nephew.com/logout',
    cloudFrontCLPExitAppUrl: 'https://clp.qa5.bridge.sportsmed.smith-nephew.com/application/product',
  },
  //SNN ROLE
  snnClp: {
    hostedUIUrl: "https://bridge-qa5-snn-auth.auth.us-east-2.amazoncognito.com/oauth2/",
    hostedUIlogout: "https://bridge-qa5-snn-auth.auth.us-east-2.amazoncognito.com/logout",
    identityPoolId: "us-east-2:4df5382f-0200-41c6-abd2-0db192e168c6",
    userPoolId: "us-east-2_OiA1qTOKG",
    userPoolWebClientId: "20odvjj6d7d585487lkac4crff",
    userPoolAwsLogin: "cognito-idp.us-east-2.amazonaws.com/us-east-2_OiA1qTOKG",
    cloudfrontCLPURL: 'https://snn.qa5.bridge.sportsmed.smith-nephew.com',
    cloudFrontCLPSignInUrl: 'https://snn.qa5.bridge.sportsmed.smith-nephew.com/signin',
    cloudFrontCLPSignOutUrl: 'https://snn.qa5.bridge.sportsmed.smith-nephew.com/logout',
    cloudFrontCLPExitAppUrl: 'https://snn.qa5.bridge.sportsmed.smith-nephew.com/application/product',
  },
  duuCloudFrontSigninUrl: 'https://duu.qa5.bridge.sportsmed.smith-nephew.com/signin',
};
